import React, { useState, ChangeEvent, useEffect } from 'react'
import { Input } from '@rockr/rock-ui'
import {mountEvent} from '../../shared/helpers/input'

type Props = {
  name: string
  currency: 'BRL' | 'USD'
  disabled?: boolean
  value?: number
  onChange?: (e: ChangeEvent<any>) => any
  min?: number
  max?: number
  isInvalid?: boolean
}

const locales = {
  BRL: 'pt-BR',
  USD: 'en-US'
}

export const MoneyInput: React.FC<Props> = ({
  name,
  currency,
  disabled,
  value: defaultValue,
  onChange,
  min,
  max,
  isInvalid
}) => {
  const [value, setValue] = useState(defaultValue?.toString())

  const locale = locales[currency]
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency
  })

  const getValueToUpdate = (rawValue: string) => {
    if (max && Number(rawValue) > max) {
      return max
    }

    if (min && Number(rawValue) < min) {
      return min
    }

    return rawValue
  }

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target
    const onlyNumbers = value.replace(/[^0-9]/g, '')
    const valueToUpdate = getValueToUpdate(onlyNumbers)
    const amount = formatter.format(Number(valueToUpdate) / 100)
    const rawEvent = mountEvent(name, valueToUpdate)
    setValue(amount)
    onChange?.(rawEvent as ChangeEvent<any>)
  }

  useEffect(() => {
    if (!isNaN(defaultValue || 0)) {
      const amount = formatter.format(defaultValue! / 100)
      const rawEvent = mountEvent(name, defaultValue!)
      setValue(amount)
      onChange?.(rawEvent as ChangeEvent<any>)
    }
    // eslint-disable-next-line
  }, [defaultValue])

  return (
    <Input
      isInvalid={isInvalid}
      name={name}
      isDisabled={disabled}
      value={value}
      onChange={handleInputChange}
    />
  )
}
